import { ComponentPropsWithoutRef } from "react";
import cx from "classnames";

import styles from "./TableHeader.module.scss";

/**
 * Props for the TableHeader component
 * @extends ComponentPropsWithoutRef<"thead">
 * @extends ComponentPropsWithoutRef<"div">
 */
export type TableHeaderProps =
  | ({
      /**
       * The type of table being rendered
       */
      type: "simple";
    } & ComponentPropsWithoutRef<"thead">)
  | ({
      /**
       * The type of table being rendered
       */
      type: "data-table";
    } & ComponentPropsWithoutRef<"div">);

/**
 * Table header component for simple presentational or complex data tables
 * @param props - The props for the TableHeader component
 * @param props.type - The type of table being rendered
 * @param props.children - The children of the TableHeader component
 * @param props.ref - The ref of the TableHeader component
 */
export function TableHeader({ type, children, ...rest }: TableHeaderProps) {
  const classes = cx(styles["table-header"], rest.className);

  const Element = type === "simple" ? "thead" : "div";
  return (
    <Element
      {...rest}
      className={classes}
      role={type === "simple" ? undefined : "rowgroup"}
    >
      {children}
    </Element>
  );
}
